import SigninSignup from '@/js/components/common/ui/SigninSignup.vue';
import { mountModal } from './helper/dynamic-modal';

export const signinSignup = ({ active, next, callback }: { active?: string; next?: string; callback?: () => void } = {}) => {
  mountModal({
    Component: SigninSignup,
    props: {
      active,
      next,
      callback,
    },
  });
};
